
  <div class="row card-deck">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">

      <div class="card-header wh-header border-bottom">
        Edit Service
        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
        <div class="modal-body overflow-x">

          <section id="form-action-layouts">


            <div class="row justify-content-md-center">
              <div class="col-md-12 padding-left-0px">
                <div class="card">

                  <div class="card-body">
                    <div class="px-6">



                      <div class="form-body">
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName"> Name </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="text" class="form-control padding-left-0px">

                              </div>
                              <div class="col-md-3 text-align-right">
                                <label for="firstName">Service Category </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">
                                <CodeTypeValue CodeType="MARTL"></CodeTypeValue>


                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName">BasePrice </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="text" class="form-control padding-left-0px">

                              </div>
                              <div class="col-md-3 text-align-right">
                                <label for="firstName">Revenue Category </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">
                                <CodeTypeValue CodeType="MARTL"></CodeTypeValue>


                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName"> Is Taxable </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="checkbox" class="form-control padding-left-0px  width-20">

                              </div>
                              <div class="col-md-3 text-align-right">
                                <label for="firstName">Editable Charge </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">
                                <CodeTypeValue CodeType="MARTL"></CodeTypeValue>


                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName">Tax(%) </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="text" class="form-control padding-left-0px">

                              </div>
                              <div class="col-md-3 text-align-right">
                                <label for="firstName">Refund Allowed </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">
                                <input type="checkbox" class="form-control padding-left-0px width-20">


                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName">Is Tax Included in Price? </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="checkbox" class="form-control padding-left-0px width-20">

                              </div>
                              <div class="col-md-3 text-align-right">
                                <label for="firstName">Edit Approval Requird </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">
                                <input type="checkbox" class="form-control padding-left-0px width-20">


                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName">Is Commission Allowed? </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="checkbox" class="form-control padding-left-0px width-20">

                              </div>
                              <div class="col-md-3 text-align-right">
                                <label for="firstName">Refund Approval Required </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">
                                <input type="checkbox" class="form-control padding-left-0px width-20">


                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName">Default Commission </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="text" class="form-control padding-left-0px">

                              </div>
                              <div class="col-md-3 text-align-right">
                                <label for="firstName">Service Type </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">
                                <CodeTypeValue CodeType="MARTL"></CodeTypeValue>


                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName">Minimum Commission </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="text" class="form-control padding-left-0px">

                              </div>
                              <div class="col-md-3 text-align-right">
                                <label for="firstName">UOM </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">
                                <input type="text" class="form-control padding-left-0px">


                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName">Maximum Commission </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="text" class="form-control padding-left-0px">

                              </div>
                              <div class="col-md-3 text-align-right">
                                <label for="firstName">Note </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">
                                <textarea class="form-control3" rows="2" placeholder="Note"></textarea>


                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName">Is Discount Allowed? </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="checkbox" class="form-control padding-left-0px width-20">

                              </div>
                              <div class="col-md-3 text-align-right">
                                <label for="firstName">Max Discount Allowed </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">
                                <input type="text" class="form-control padding-left-0px">


                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-right-0px">
                            <div class="row">
                              <div class="col-md-2 text-align-right padding-left-0px">
                                <label for="firstName">Billing Category Applicable </label>
                              </div>
                              <div class="col-md-3 padding-left-0px">

                                <input type="checkbox" class="form-control padding-left-0px width-20">

                              </div>
                             
                            </div>

                          </div>
                        </div>
                      </div>




               





                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          
        </div>


        <div class="modal-footer">
         <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Cancel</button>
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime margin-right-auto">Save</button>

        </div>

      </form>
    </div>
    </div>
 
